<template>
  <div class="hello">
    <nav class="navigation">
      <img class="logo" :src="require('../assets/images/mauloa-logo.svg')" @click="scrollAnchor('html')">
      <ul>
        <li><a href="#" @click="scrollAnchor('.news')">News</a></li>
        <li><a href="#" @click="scrollAnchor('.about')">About</a></li>
        <li><a href="#" @click="scrollAnchor('.lesson')">Lesson</a></li>
        <li><a href="#" @click="scrollAnchor('.class')">Class</a></li>
        <li><a href="#" @click="scrollAnchor('.timetable')">Time</a></li>
        <li><a href="#" @click="scrollAnchor('.staff')">Staff</a></li>
        <li><a href="#" @click="scrollAnchor('.contact')">Contact</a></li>
      </ul>
    </nav>

    <section class="main">
      <img class="logo" :src="require('../assets/images/mauloa-logo-white.svg')">
      <p>仙台駅東口から徒歩7分<br>初心者からインストラクターを目指す方まで<br>本格的なフラを習えます</p>
      <p class="comment">無料体験OK!!　*事前予約をお願いします</p>
      <p class="comment">2019年3月末日迄ご入会の方に入会金25％OFF＆<br>マウロアオリジナルTシャツプレゼント!!</span></p>
    </section>

    <section class="news">
      <div class="content-center">
        <h1>News</h1>
        <section>
          <h2>2019.9.7(土)</h2>
          <p>8th 伊達なHula Festa 福祉プラザ2Fふれあいホールにて開催決定</p>
        </section>
        <section>
          <h2>2018.7.8(日)</h2>
          <p>7th 伊達なHula Festa<br>福祉プラザ アウアナ、カヒコ、タヒチアンに加えて<br>
          今年も県外よりカネダンサーを招待<br>フラショップも出店します</p>
        </section>
        <section>
          <h2>2017.11.3(金) 祝日</h2>
          <p>青葉区民まつり<br> HulaとUkulele&Hulaの両方での参加です</p>
        </section>
        <section>
          <h2>2017.8.18(土)</h2>
          <p>E BeanS杜のテラスにてライブ <br>18:30～ 19:30～の2回ステージ</p>
        </section>
        <section>
          <h2>2017.8.6(日)</h2>
          <p>イロハ横丁七夕イベント<br>今年で3回目の参加になります<br>・13:00～ Hula<br>・15:30～ Ukulele&Hula</p>
        </section>
        <section>
          <h2>2017.7.1(土)</h2>
          <p>6th伊達なHula Festa 福祉プラザにて開催<br> カヒコ、ケイキさんに加えて、<br>今回は県外よりカネダンサーを招待</p>
        </section>
      </div>
    </section>

    <section class="about">
      <h1>About</h1>
      <p><span class="accent">「マウロア」</span>とは、ハワイ語で、「永遠」という意味です。<br> 生徒さんは、オハナ(家族)としてレッスンを共に励み、人と人の繋がりも大切にしています。 </p>
      <ul class="bold">
        <li>＊ レッスンでは基礎を大切にして、美しく踊ることを一番の目標にしています。</li>
        <li>＊ <span class="accent">マウロア レッスンの特徴</span> やわらかに踊る<br>アウアナだけでなく、各フラの楽器(ウリウリ、イプ、プイリ)を使って楽しく踊ります。</li>
        <li>＊ 古典フラのカヒコもご指導しています</li>
        <li>＊ ウクレレとフラソングも楽しくレッスンをしています。 </li>
      </ul>
      <p>以上のようにマウロアでは様々な種類のレッスンを受けることが出来ますので
      更にフラを身近に感じることができます。</p>
    </section>

    <section class="lesson">
      <div class="content-center">
        <h1>Lesson</h1>
        <ul class="bold">
          <li>＊カヒコ(古典フラ)</li>
          <li>＊アウアナ(現代フラ)</li>
          <li>＊各楽器(イプ、ウリウリ、プイリ 他)</li>
          <li>＊ウクレレ＆フラソング </li>
          <!--<li>＊またにてぃ６＆シェイプフラ</li>-->
          <li>＊パーティ・イベントでの生演奏</li>
          <li>＊出張レッスン</li>
          <li>＊ワークショップ(ご相談ください) 慰問活動(ボランティア)</li>
        </ul>
      </div>
    </section>

    <section class="class">
      <div class="content-center">
        <h1>Class</h1>
        <section class="class-addmission">
          <h2>入会金</h2>
          <table class="table">
            <tr><td>フラ<br>(マウロアオリジナルTシャツ、ＣＤ、ファイル付)</td><td>13,000円</td></tr>
            <tr><td>ウクレレ</td><td>3,000円</td></tr>
            <!--<tr><td>マタニティ＆シェイプ</td><td>2,000円</td></tr>-->
            <tr><td>カヒコ<br>(マウロアオリジナルTシャツ、ＣＤ、ファイル付)</td><td>8,000円<br></td></tr>
          </table>
        </section>
        <section class="class-addmission">
          <h2>レッスン料金<span>（レッスンは基本的に月4回となります）</span></h2>
          <table class="table">
            <tr><td>初級クラス(80分)</td><td>7,300円</td></tr>
            <tr><td>中級クラス(80分)</td><td>8,800円</td></tr>
            <tr><td>インストラクタークラス</td><td>15,000円</td></tr>
            <tr><td>ガールズクラス<br>(高校生まで:80分)</td><td>5,800円</td></tr>
            <tr><td>カネクラス(80分)</td><td>8,500円</td></tr>
            <tr><td>ケイキクラス<br>(小学生)</td><td>5,800円</td></tr>
            <tr><td>ママ＆ケイキクラス<br>(幼児)(80分)</td><td>6,800円</td></tr>
            <tr><td>マダムのゆったりフラ<br>(月に2回70分)</td><td>4,000円</td></tr>
            <!--<tr><td>マタニティ＆シェイプフラ<br>(3ヵ月有効の6回分のチケット:70分)<br>※安定期＋産後に利用できます。チケットの追加購入も出来ます。</td><td>9,000円</td></tr>-->
            <tr><td>カヒコクラス<br>(月2回:60分)</td><td>5,000円</td></tr>
            <tr><td>個人レッスン<br>(1レッスン:80分)</td><td>6,000円</td></tr>
            <tr><td>ウクレレ＆フラソング 初級<br>(月2回:60分)</td><td>3,000円</td></tr>
            <tr><td>ウクレレ＆フラソング 初級<br>(月4回:60分)</td><td>5,500円</td></tr>
            <tr><td>ウクレレ＆フラソング 中級<br>(月2回:60分)</td><td>4,000円</td></tr>
            <tr><td>ウクレレ＆フラソング 中級<br>(月4回:60分)</td><td>7,500円</td></tr>
          </table>
        </section>
        <p class="class-annotation">※全てのレッスンは曜日･時間について相談に応じることが可能です</p>
      </div>
    </section>

    <section class="timetable">
      <div class="content-center">
        <h1>Time Table</h1>
        <section>
          <h2>火曜日</h2>
          <p>15:30～16:50(80分) 初級・中級<br>18:00～19:20(80分) 初級・中級</p>
        </section>
        <section>
          <h2>金曜日<span>(基本は第1・第3の月2回 ※相談可)</span></h2>
          <p>18:30～19:30(60分) 中級<br>19:30～20:30(60分) カヒコ</p>
        </section>
        <section>
          <h2>土曜日</h2>
          <p>
          9:50～11:10(80分) 初級・ケイキ<br>
          15:00～16:00(60分) ウクレレ<br><br>
          ＜カヒコのある日＞<br>
          16:00〜17:00(60分) カヒコ 月2回<br>
          17:00〜18:20(80分) 中級〜(初級)<br><br>
          ＜カヒコのない日＞<br>
          16:00〜17:20(80分) 中級〜(初級)<br>
          17:30〜18:50(80分) インストラクター(月2回)
          </p>

        </section>
      </div>
    </section>

    <section class="staff">
      <div class="content-center">
        <h1>Staff</h1>
        <section>
          <h2>主宰</h2>
          <p>安達 幸子 (Eneo Anela Sachiko)</p>
        </section>
        <section>
          <h2>インストラクター</h2>
          <p>安逹 沙綾 (Hibiscus Ho'okomo koko Saaya)<br>高橋 ルミ（Anapa Hoku-ke'a Lumi）<!--<br>嵯峨 千晶 (Hibiscus Ho'okomo koko Saaya)--></p>
        </section>
      </div>
    </section>

    <section class="contact">
      <div class="content-center">
        <h1>Contact</h1>
        <section>
          <h2>フラスタジオ・マウロア</h2>
          <p>〒983-0852<br> 宮城県仙台市宮城野区榴岡3-2-5<br>仙台銀行2F Lスタジオ内<br><br>TEL.090-2884-4791(10:00～20:00 安達)</p>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3132.841549315829!2d140.88435355985425!3d38.259980800503484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f8a281f23ea1863%3A0x69497a2ba9daa468!2z5LuZ5Y-w6YqA6KGM5a6u5Z-O6YeO5pSv5bqX!5e0!3m2!1sja!2sjp!4v1506902968392" width="100%" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
        </section>
      </div>
    </section>

    <footer class="footer">
      <p>©2010-2017 Hula Studio Mauloa.</p>
    </footer>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    scrollAnchor (anchor) {
      const speed = 400
      const position = $(anchor).offset().top
      $('body, html').animate({scrollTop: position}, speed, 'swing')
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.hello {
  .content-center {
    max-width: 1024px;
    margin: 0 auto;
  }
  h1 {
    font-size: 30px;
    // font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
  }
  h2 {
    font-size: 16px;
    margin-bottom: 20px;
    text-align: center;
    span {
      display: block;
      font-size: 12px;
      margin-top: 5px;
    }
  }
  p {
    margin-bottom: 30px;
    line-height: 1.4;
    font-size: 14px;
  }
  ul {
    margin-bottom: 30px;
    li {
      line-height: 1.4;
      font-size: 14px;
      margin-bottom: 25px;
    }

    &.bold li{
      font-weight: bold;
      font-size: 13px;
    }
  }

  span {
    &.accent {
      color: #E4007F;
    }
  }

  .table {
    text-align: left;
    width: 100%;
    border: 1px solid gray;
    margin-bottom: 30px;
    font-size: 13px;
    td {
      border: 1px solid gray;
      padding: 10px;
      line-height: 1.3;
      &:first-child {
        width: calc(100% - 80px);
      }
      &:last-child {
        width: 80px;
      }
    }
  }

  section {
    text-align: center;
  }

  .navigation {
    height: 40px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    padding-top: 13px;
    padding-left: 60px;
    text-align: center;
    background: url(../assets/images/footer.svg) no-repeat;
    background-size: 500%;
    background-position: bottom;
    p {
      font-size: 11px;
    }
    .logo {
      position: absolute;
      left: 10px;
      top: 7px;
      width: 45px;
    }

    li {
      float: left;
      font-size: 12px;
      width: calc((100% - 20px) / 7);
      a {
        color: inherit;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  .main {
    text-align: center;
    padding-top: 25vh;
    height: 100vh;

    .logo {
      max-width: 200px;
      margin-bottom: 15px;
    }

    p {
      color: white;
      font-size: 12px;
      max-width: 400px;
      margin: 0 auto;
    }

    .comment {
      margin-top: 10px;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .news {
    padding: 50px 30px;
    background: rgba(255, 255, 255, 0.6);
  }

  .about {
    padding: 50px 30px;
    background: #D8EFFC;
  }

  .lesson {
    padding: 50px 30px;
    background: rgba(255, 255, 255, 0.6);
  }

  .class {
    padding: 50px 30px;
    background: #D8EFFC;
    &-annotation {
      font-weight: bold;
      font-size: 16px;
    }
  }

  .timetable {
    padding: 50px 30px;
    background: rgba(255, 255, 255, 0.6);
  }

  .staff {
    padding: 50px 30px;
    background: #D8EFFC;
  }

  .contact {
    padding: 50px 30px;
    background: rgba(255, 255, 255, 0.6);
  }

  .footer {
    font-size: 12px;
    text-align: center;
    margin: 40px 0 50px;
  }
}

  

@media (max-width: 320px) {
  .main {
    padding-top: 15vh !important;
    .logo {
      width: 150px !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Hello.vue?74bed584